<template>
  <div class="suite">
    <div>
      <HeaderBar3 :preferred="preferred" :loading="loading" :showSections="true" @setSection_in="setSection_out($event)" :ref="hbref"></HeaderBar3>
    </div>
    <div v-if="section != null && sections.includes(section)">
      <!-- Devices Section-->
      <div v-if="section == 'devices' && sections.includes('devices')" class="p-2" style="margin-top: 92px;">
        <Devices :key="compkeys.devices"></Devices>
      </div>
      <!-- Users Section-->
      <div v-if="section == 'users' && sections.includes('users')" class="p-2" style="margin-top: 92px;">
        <Users :key="compkeys.users"></Users>
      </div>
      <!-- Credentials Section-->
      <div v-if="section == 'credentials' && sections.includes('credentials')" class="p-2" style="margin-top: 92px;">
        <Credentials :key="compkeys.credentials"></Credentials>
      </div>
      <!-- Apps Section-->
      <div v-if="section == 'apps' && sections.includes('apps')" class="p-2" style="margin-top: 92px;">
        <Apps :key="compkeys.credentials"></Apps>
      </div>
      <!-- Management Section-->
      <div v-if="section == 'management' && sections.includes('management')" class="p-2" style="margin-top: 92px;">
        <Management :key="compkeys.management"></Management>
      </div>
      <!-- Apps Section-->
      <div v-if="section == 'underwork' && sections.includes('underwork')" class="p-2" style="margin-top: 92px;">
        <div class="fs-1 fw-light" style="margin-top: 18%;" >
          <i class="fa-solid fa-xl fa-cog fa-spin text-warning"></i>
          <div class="fa-fade text-warning">
            Currently under work.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderBar3 from '@/components/HeaderBar3.vue'
import Devices from '@/components/apps-components/suite/Devices.vue'
import Users from '@/components/apps-components/suite/Users.vue'
import Credentials from '@/components/apps-components/suite/Credentials.vue'
import Apps from '@/components/apps-components/suite/Apps.vue'
import Management from '@/components/apps-components/suite/Management.vue'

import axios from "axios";

export default {
  name: 'Suite',
  components: {
    HeaderBar3,
    Devices,
    Users,
    Credentials,
    Apps,
    Management
  },
  data(){
    return {
      //site: process.env.VUE_APP_SERVICE_URL,  // Origin
      site: null,
      service_mode: null, // PV | PB
      stage: null,        // D  | P
      customer: null,     // Solve
      loading: false,
      // View
      view: 'suite',
      hbref: 'hb_suite',
      section: null,
      preferred: 'devices',
      sections: [],
      apps: {},

      // Components keys.
      compkeys: {
        devices: 0,
        users: 0,
        credentials: 0,
        apps: 0,
        management: 0
      }
    }
  },
  methods:{
    solve(){
      this.loading = true
      const params = {view: this.view}
      const dest = this.site + '/suite/main/dnsuite'
      axios
          .get(dest, {params})
          .then(rx => {
            this.customer = rx.data.customer
            this.username = rx.data.username
            this.apps     = rx.data.apps
            this.sections = rx.data.sections
            this.$refs[this.hbref].init(this.view, this.username, this.customer, this.sections, this.apps)
            this.loading = false
          })
          .catch(error => {
            console.log(error)
            this.loading = false
            //this.processErrorMessage(error)
          });
    },
    setSection_out(entry){
      this.section = entry
    }
  },
  created: function(){
    //localStorage.setItem('vrfaware_app','Suite')
    this.stage = process.env.NODE_ENV
    this.service_mode = process.env.VUE_APP_SERVICE_MODE
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    this.solve()
  }
}
</script>

<style scoped>
  .suite{
    overflow: hidden;
  }
</style>
